import { useEffect, useState } from 'react';
import { renderARElements, renderARMarker } from '../../../../helper/ar';
import { IConfig } from '../../../../interface/game';
import MarkerBasedSceneInit from './MarkerBasedSceneInit';
import { loadScript } from '../../../../util/script';
import { AframeListener } from '../js/aframeListener';
import ARCaptureBtn from '@/component/common/Button/ARCaptureBtn/ARCaptureBtn';
import MarkerBasedInstruction from './MarkerBasedInstruction';
import GameTimer from '../GameTimer';

const scripts = [
  {
    uri: 'https://aframe.io/releases/1.7.1/aframe.min.js',
  },
  {
    uri: 'https://raw.githack.com/AR-js-org/AR.js/master/aframe/build/aframe-ar.js',
  },
  {
    uri: 'https://cdn.jsdelivr.net/gh/c-frame/aframe-extras@7.4.0/dist/aframe-extras.min.js',
  },
  {
    uri: 'https://rawgit.com/donmccurdy/aframe-extras/master/dist/aframe-extras.loaders.min.js',
  },
];

type MarkerBasedContentProps = {
  config?: IConfig;
};

const MarkerBasedContent = ({ config }: MarkerBasedContentProps) => {
  const [isAframeListenerLoaded, setIsAframeListenerLoaded] = useState(false);
  const [isScriptLoaded, setScriptLoaded] = useState(false);
  const [markerThumbnail, setMarkerThumbnail] = useState();

  const renderMarker = (elements: any) => {
    const markerElement = elements.find((ele: any) => ele.type === 'MARKER');
    if (markerElement) {
      renderARMarker(markerElement?.uri);
      setMarkerThumbnail(markerElement?.thumbnail);
    }
  };
  const renderElements = () => {
    const elements = config?.elements || [];
    renderMarker(elements);
    renderARElements(elements, undefined, 'MARKERBASED');
  };

  const onLoadScripts = async () => {
    if (isScriptLoaded) return;
    for (const item of scripts) {
      await loadScript(item.uri);
    }
    setScriptLoaded(true);
  };
  useEffect(() => {
    onLoadScripts();
  }, []);
  useEffect(() => {
    if (!isScriptLoaded) return;
    if (isAframeListenerLoaded) {
      const scene: any = document.querySelector('a-scene');
      if (scene && scene.hasLoaded) {
        renderElements();
      } else if (scene) {
        scene.addEventListener('loaded', renderElements);
      }
    }
    if (!isAframeListenerLoaded) {
      new AframeListener();
      setIsAframeListenerLoaded(true);
    }
  }, [isAframeListenerLoaded, isScriptLoaded]);
  if (!isScriptLoaded) return <div>Loading AR experience...</div>;
  return (
    <>
      <MarkerBasedSceneInit />
      <ARCaptureBtn />
      {markerThumbnail && (
        <MarkerBasedInstruction markerThumbnail={markerThumbnail} />
      )}
      <GameTimer timer={config?.timer} />
    </>
  );
};

export default MarkerBasedContent;
